import { render, staticRenderFns } from "./TdInfoLots.vue?vue&type=template&id=56337e11"
import script from "./TdInfoLots.vue?vue&type=script&lang=js"
export * from "./TdInfoLots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports